/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The reviewer's ground-truth verdict.
 */
export const Verdict = {
  Correct: "correct",
  FalsePositive: "false_positive",
  Missed: "missed",
} as const;
/**
 * The reviewer's ground-truth verdict.
 */
export type Verdict = OpenEnum<typeof Verdict>;

export type RiskPolicyEvalReview = {
  /**
   * The chat session being judged.
   */
  chatId: string;
  /**
   * When the verdict was first recorded.
   */
  createdAt: Date;
  /**
   * The review ID.
   */
  id: string;
  /**
   * The prompt-based policy the verdict belongs to.
   */
  policyId: string;
  /**
   * The policy version in effect when the verdict was recorded (provenance).
   */
  policyVersion: number;
  /**
   * User id of the reviewer who recorded the verdict.
   */
  reviewedBy: string;
  /**
   * When the verdict was last updated.
   */
  updatedAt: Date;
  /**
   * The reviewer's ground-truth verdict.
   */
  verdict: Verdict;
};

/** @internal */
export const Verdict$inboundSchema: z.ZodMiniType<Verdict, unknown> = openEnums
  .inboundSchema(Verdict);

/** @internal */
export const RiskPolicyEvalReview$inboundSchema: z.ZodMiniType<
  RiskPolicyEvalReview,
  unknown
> = z.pipe(
  z.object({
    chat_id: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    policy_id: z.string(),
    policy_version: z.int(),
    reviewed_by: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    verdict: Verdict$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "created_at": "createdAt",
      "policy_id": "policyId",
      "policy_version": "policyVersion",
      "reviewed_by": "reviewedBy",
      "updated_at": "updatedAt",
    });
  }),
);

export function riskPolicyEvalReviewFromJSON(
  jsonString: string,
): SafeParseResult<RiskPolicyEvalReview, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPolicyEvalReview$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPolicyEvalReview' from JSON`,
  );
}
